import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { AppSettings } from '../app.settings';

@Injectable()
export class IPService {
  constructor(private http: HttpClient, private settings: AppSettings) {}

  public getIP() {
    const properties = this.settings.getValue('properties') || {};
    const debugIp = properties.debug_ip;
    const url =
      'https://geo.idonate.com/?fields=countryCode,status' +
      (debugIp ? `&ip=${encodeURIComponent(debugIp)}` : '');
    return this.http.get(url).pipe(
      map(response => {
        if (!response) {
          return { countryCode: 'US' };
        }

        if (!response['countryCode']) {
          response['countryCode'] = 'US';
        }

        return response;
      }),
      catchError(err => {
        // swallow error and return default US
        return of({ countryCode: 'US' });
      })
    );
  }
}
